export const VARIANTS = [256, 1024, 2560] as const;
export type Variant = (typeof VARIANTS)[number];

/**
 * Resolves an asset to a displayable URL for one of its variants ('' while unknown). Server boards also notify
 * when URLs arrive, give a thumbhash placeholder and say which assets are still uploading.
 */
export type MediaResolver = {
  urlFor(assetId: string, variant: Variant): string;
  subscribe?(cb: () => void): () => void;
  placeholder?(assetId: string): string | null;
  uploading?(assetId: string): boolean;
  /** Pixel size of an asset's source, null while unknown (a peer's upload not listed yet). */
  info?(assetId: string): { w: number; h: number } | null;
};

/** Smallest variant whose long edge covers the on-screen device pixels, optionally capped (low-end devices). Copied from the J1 spike. */
export function chooseVariant(screenPx: number, dpr: number, cap: Variant = 2560): Variant {
  const need = screenPx * dpr;
  const allowed = VARIANTS.filter((v) => v <= cap);
  return allowed.find((v) => v >= need) ?? allowed[allowed.length - 1]!;
}
